import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Currency, Marketplace } from "@front/m19-api-client";
import { CurrencySymbols } from "@front/m19-models";
import {
  IButtonDirective,
  IFormFieldComponent,
  IInputDirective,
  ILabelComponent,
  ITooltipDirective,
  MODAL_DATA,
  ModalRef,
} from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { ProductViewComponent } from "@m19-board/product-view/product-view.component";

export type CogsUpdateModalOutput = { startDate: string; costOfGoods: number }[] | "deletion";

export interface CogsUpdateModalData {
  asin: string;
  marketplace: Marketplace;
  locale: string;
  currency: Currency;
  cogsValue: number | undefined;
}

@Component({
  selector: "app-cogs-upload-modal",
  templateUrl: "./cogs-upload-modal.component.html",
  imports: [
    ProductViewComponent,
    TranslocoDirective,
    FormsModule,
    IButtonDirective,
    ITooltipDirective,
    IFormFieldComponent,
    ILabelComponent,
    IInputDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CogsUpdateModalComponent implements OnInit {
  modalData = inject<CogsUpdateModalData>(MODAL_DATA);
  modalRef = inject(ModalRef);

  currencySymbol = CurrencySymbols[this.modalData.currency];
  cogValue = signal<string | null>(null);

  ngOnInit() {
    if (this.modalData.cogsValue) {
      this.cogValue.set(this.modalData.cogsValue.toString());
    } else {
      this.cogValue.set(null);
    }
  }

  updateCostOfGood(cogValue: string) {
    this.modalRef.close(Number.parseFloat(cogValue));
  }

  deleteCostOfGood() {
    this.modalRef.close(0);
  }

  closeModal() {
    this.modalRef.close();
  }
}
